import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  "data-qa": "mini-wizard-credits-box"
}
const _hoisted_2 = { class: "_flex _ai-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")

  return (_ctx.hasPositiveCreditsBalance)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", {
            class: _normalizeClass($options.captionClass)
          }, [
            _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.MiniWizardCreditValueText) + " ", 1 /* TEXT */),
            _createVNode(_component_tooltip, {
              text: _ctx.Resources.ProjectHome.MiniWizardCreditValueTooltip
            }, {
              default: _withCtx(() => [
                _createVNode(_component_base_icon, {
                  name: "exclamation-circle",
                  class: "_ml-h"
                })
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["text"])
          ], 2 /* CLASS */),
          _createElementVNode("strong", {
            class: _normalizeClass($options.amountClass),
            "data-qa": "available-credits-box:Amount"
          }, _toDisplayString($options.creditBalanceFormatted), 3 /* TEXT, CLASS */)
        ])
      ]))
    : _createCommentVNode("v-if", true)
}